export default __webpack_public_path__ + "70580c8de5519790f805fa3a2e49f3ab.jpg";